import React, { useEffect, useState } from "react";
import axios from "axios";
import { Form, Row, Col, Button, Card } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { baseUrl, userRoles } from "../Utility/constants";
import useSchoolData from "../hooks/useSchoolData";
import MainHeader from "./common/MainHeader";
import { useAsyncError, useNavigate } from "react-router-dom";

const NewUserRegistration = () => {

    const {
        schoolInfo,
        schoolContactInfo,
    } = useSchoolData();

    const navigate = useNavigate();

    const [genderMaster, setGenderMaster] = useState([]);
    const [loading, setLoading] = useState(false);
    const [greetingMessage, setGreetingMessage] = useState("");
    const [showModal, setShowModal] = useState(false);

    //const school_Name = (id) => schoolList.find(x => x.schoolId == id).schoolOrCollegeName;

    const [formData, setFormData] = useState({
        fullName: "",
        gender: "",
        dateOfBirth: "",
        joiningDate: "",
        phone: "",
        email: "",
        password: "",
        role: "",
        aadhaarCardNumber: "",
        retirementDate: "",
        status: "PENDING"
    });

    const getGreeting = () => {
        const hours = new Date().getHours();
        if (hours < 12) return "Good morning";
        if (hours < 17) return "Good afternoon";
        return "Good evening";
    };

    // -----------------------------------------
    // Load Gender Master
    // -----------------------------------------

    useEffect(() => {

        const fetchGenderMaster = async () => {

            try {

                const response = await axios.get(
                    `${baseUrl}/api/CommonMaster/GetGenderMasters`
                );

                setGenderMaster(response.data);

            } catch (error) {

                console.error(
                    "Failed to load gender details.",
                    error
                );

                toast.error(
                    "Failed to load gender details."
                );
            }
        };

        fetchGenderMaster();

    }, []);


    // -----------------------------------------
    // Calculate Retirement Date
    // Same logic as existing AddNewTeacherModal
    // -----------------------------------------

    const calculateRetirementDate = (dob) => {

        const retirementYear =
            dob.getFullYear() + 58;

        const dobDay =
            dob.getDate();

        let retirementDateObj;

        if (dobDay === 1) {

            // Last day of previous month
            retirementDateObj = new Date(
                retirementYear,
                dob.getMonth(),
                0
            );

        } else {

            // Last day of current month
            retirementDateObj = new Date(
                retirementYear,
                dob.getMonth() + 1,
                0
            );
        }

        return retirementDateObj
            .toISOString()
            .split("T")[0];
    };


    // -----------------------------------------
    // Handle Input Change
    // -----------------------------------------

    const handleChange = (e) => {

        const { name, value } = e.target;

        let updatedFields = {};

        // Automatically calculate retirement date
        // whenever Date of Birth changes
        if (name === "dateOfBirth" && value) {

            const dob = new Date(value);

            if (!isNaN(dob)) {

                const retirementDate =
                    calculateRetirementDate(dob);

                updatedFields.retirementDate =
                    retirementDate;
            }
        }

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
            ...updatedFields
        }));
    };


    // -----------------------------------------
    // Number Input
    // -----------------------------------------

    const handleNumberChange = (e, maxLength) => {

        const { name, value } = e.target;

        // Allow only numbers
        if (!/^\d*$/.test(value)) {
            return;
        }

        // Maximum length
        if (value.length > maxLength) {
            return;
        }

        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };


    // -----------------------------------------
    // Validate Form
    // -----------------------------------------

    const validateForm = () => {

        if (!formData.fullName.trim()) {

            toast.error(
                "Full Name is required"
            );

            return false;
        }


        if (!formData.gender) {

            toast.error(
                "Gender is required"
            );

            return false;
        }


        if (!formData.dateOfBirth) {

            toast.error(
                "Date of Birth is required"
            );

            return false;
        }


        if (!formData.joiningDate) {

            toast.error(
                "Joining Date is required"
            );

            return false;
        }


        if (!formData.phone) {

            toast.error(
                "Phone number is required"
            );

            return false;
        }


        if (formData.phone.length !== 10) {

            toast.error(
                "Phone number must be 10 digits"
            );

            return false;
        }


        if (!formData.email) {

            toast.error(
                "Email is required"
            );

            return false;
        }


        if (!formData.password) {

            toast.error(
                "Password is required"
            );

            return false;
        }


        if (!formData.role) {

            toast.error(
                "Role is required"
            );

            return false;
        }


        if (!formData.aadhaarCardNumber) {

            toast.error(
                "Aadhaar number is required"
            );

            return false;
        }


        if (
            formData.aadhaarCardNumber.length !== 12
        ) {

            toast.error(
                "Aadhaar must be 12 digits"
            );

            return false;
        }


        if (!formData.retirementDate) {

            toast.error(
                "Retirement date could not be calculated"
            );

            return false;
        }


        return true;
    };

    const handleCloseModal = () => {
        setShowModal(false);
        navigate("/");
    };

    // -----------------------------------------
    // Submit Form
    // -----------------------------------------

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        try {

            setLoading(true);

            const fd = new FormData();


            // ---------------------------------
            // Mandatory Fields
            // ---------------------------------

            fd.append(
                "fullName",
                formData.fullName
            );

            fd.append(
                "gender",
                formData.gender
            );

            fd.append(
                "dateOfBirth",
                formData.dateOfBirth
            );

            fd.append(
                "joiningDate",
                formData.joiningDate
            );

            fd.append(
                "phone",
                formData.phone
            );

            fd.append(
                "email",
                formData.email
            );

            fd.append(
                "password",
                formData.password
            );

            fd.append(
                "role",
                formData.role
            );

            fd.append(
                "aadhaarCardNumber",
                formData.aadhaarCardNumber
            );


            // ---------------------------------
            // Automatically Calculated
            // ---------------------------------

            fd.append(
                "retirementDate",
                formData.retirementDate
            );


            // ---------------------------------
            // Default Values
            // ---------------------------------

            fd.append(
                "teacherType",
                ""
            );

            fd.append(
                "salary",
                "0"
            );

            fd.append(
                "grantTypes",
                ""
            );

            fd.append(
                "educationalQualification",
                ""
            );

            fd.append(
                "payScaleSalary",
                ""
            );

            fd.append(
                "chartType",
                ""
            );

            fd.append(
                "postType",
                ""
            );

            fd.append(
                "designation",
                ""
            );

            fd.append(
                "vaiyaktikManyata",
                "NO"
            );


            // ---------------------------------
            // API Call
            // ---------------------------------
            debugger
            await axios.post(
                `${baseUrl}/api/Teachers`,
                fd,
                {
                    headers: {
                        "Content-Type":
                            "multipart/form-data"
                    }
                }
            );

            const greeting = getGreeting();

            const message = `
      Dear <b>${formData.fullName}</b>, ${greeting}<br/><br/>
      Welcome! to <b>${schoolInfo.schoolOrCollegeName}!</b> Your registration is confirmed. 
      You can now access your account by logging in with your credentials. <br/><br/>
      If you have any questions or need further assistance, please feel free to contact our support team at 
      <b>support@panaceaschool.in</b> or click here to <a href="https://wa.me/message/MOB7252C62JAC1" target="_blank">WhatsApp</a> or call us at <b>9607081662</b>
      `;
            setGreetingMessage(message);


            const studentFullName = `${formData.fullName}`.trim();
            const phone = `91${formData.phone}`;

            const whatsappUrl = `https://chatbotmarketing.in/api/v1/whatsapp/send/template?apiToken=11446%7CxR4BBpvQmkRyJXIW0dWSneCK6L2zzDWkIe7KPDMB3c98b270&phone_number_id=693821633824945&template_id=224174&templateVariable-fullname-1=${formData.fullName}&templateVariable-websitename-2=${schoolContactInfo.websiteName}&templateVariable-aadharno-3=${formData.aadhaarCardNumber}&templateVariable-password-4=${formData.password}&templateVariable-role-5=${document.getElementsByName('role')[0].value}&templateVariable-teachertype-6=''&templateVariable-schoolname-7=${schoolInfo.schoolOrCollegeName}&phone_number=${formData.phone}`
            console.log(whatsappUrl)
            axios.get(whatsappUrl)
                .then((res) => {
                    console.log("WhatsApp message sent successfully");
                })
                .catch((err) => {
                    console.error("Failed to send WhatsApp message", err);
                });

            // ---------------------------------
            // Success
            // ---------------------------------

            setShowModal(true);

            // ---------------------------------
            // Reset Form
            // ---------------------------------

            // setFormData({
            //     fullName: "",
            //     gender: "",
            //     dateOfBirth: "",
            //     joiningDate: "",
            //     phone: "",
            //     email: "",
            //     password: "",
            //     role: "",
            //     aadhaarCardNumber: "",
            //     retirementDate: ""
            // });


        } catch (error) {

            console.error(
                "Registration failed:",
                error
            );


            if (error?.response?.data) {

                toast.error(
                    error.response.data
                );

            } else {

                toast.error(
                    "Failed to complete registration."
                );
            }

        } finally {

            setLoading(false);
        }
    };


    return (
        <>
            {/* -------------------------------- */}
            {/* EXISTING HEADER - KEPT */}
            {/* -------------------------------- */}

            <MainHeader
                orgname={
                    schoolInfo?.schoolOrCollegeName
                }
            />


            {/* -------------------------------- */}
            {/* EXISTING WELCOME SECTION - KEPT */}
            {/* -------------------------------- */}

            <div className="mt-5">

                {
                    (schoolInfo?.organizationName &&
                        schoolContactInfo?.city) &&

                    <div className="text-center mb-5">

                        <h4>
                            Welcome to{" "}
                            {schoolInfo?.organizationName}
                            {" (Since "}
                            {schoolInfo?.establishmentYear}
                            {")"}
                        </h4>
                        <h2>
                            {schoolInfo?.schoolOrCollegeName}, {schoolContactInfo?.city},
                            Tal.{schoolContactInfo?.taluka}, Dist.{schoolContactInfo?.district}
                            -{schoolContactInfo?.pincode}
                        </h2>
                    </div>
                }

            </div>


            {/* -------------------------------- */}
            {/* REGISTRATION FORM */}
            {/* -------------------------------- */}

            <Row className="row justify-content-center">

                <Col md={10} lg={9}>

                    <Card className="shadow-sm">


                        {/* CARD HEADER */}

                        <Card.Header
                            className="bg-default text-black"
                        >
                            <h5 className="mb-0">
                                New Staff Registration for the Academic Year -
                                <span className="text-success fw-bold"> {schoolInfo?.currentSession}</span>
                            </h5>
                        </Card.Header>


                        <Card.Body>

                            <Form
                                onSubmit={handleSubmit}
                            >


                                {/* ================================= */}
                                {/* BASIC DETAILS */}
                                {/* ================================= */}

                                {/* <h5 className="mb-3">
                                    Basic Details
                                </h5> */}


                                <Row className="mb-3">


                                    {/* Full Name */}

                                    <Col md={4}>

                                        <Form.Group>

                                            <Form.Label>

                                                Full Name

                                                <span className="text-danger">
                                                    {" "}*
                                                </span>

                                            </Form.Label>


                                            <Form.Control
                                                type="text"
                                                name="fullName"
                                                value={
                                                    formData.fullName
                                                }
                                                onChange={
                                                    handleChange
                                                }
                                                placeholder="Enter full name"
                                                required
                                            />

                                        </Form.Group>

                                    </Col>


                                    {/* Gender */}

                                    <Col md={4}>

                                        <Form.Group>

                                            <Form.Label>

                                                Gender

                                                <span className="text-danger">
                                                    {" "}*
                                                </span>

                                            </Form.Label>


                                            <Form.Select
                                                name="gender"
                                                value={
                                                    formData.gender
                                                }
                                                onChange={
                                                    handleChange
                                                }
                                                required
                                            >

                                                <option value="">
                                                    Select Gender
                                                </option>


                                                {
                                                    genderMaster.map(
                                                        (item) => (

                                                            <option
                                                                key={
                                                                    item.id
                                                                }
                                                                value={
                                                                    item.id
                                                                }
                                                            >

                                                                {
                                                                    item.name
                                                                }

                                                            </option>

                                                        )
                                                    )
                                                }

                                            </Form.Select>

                                        </Form.Group>

                                    </Col>


                                    {/* Date Of Birth */}

                                    <Col md={4}>

                                        <Form.Group>

                                            <Form.Label>

                                                Date of Birth

                                                <span className="text-danger">
                                                    {" "}*
                                                </span>

                                            </Form.Label>


                                            <Form.Control
                                                type="date"
                                                name="dateOfBirth"
                                                value={
                                                    formData.dateOfBirth
                                                }
                                                onChange={
                                                    handleChange
                                                }
                                                required
                                            />

                                        </Form.Group>

                                    </Col>

                                </Row>


                                {/* ================================= */}
                                {/* CONTACT DETAILS */}
                                {/* ================================= */}

                                {/* <h5 className="mb-3 mt-4">
                                    Contact Details
                                </h5> */}


                                <Row className="mb-3">


                                    {/* Phone */}

                                    <Col md={4}>

                                        <Form.Group>

                                            <Form.Label>

                                                Phone Number

                                                <span className="text-danger">
                                                    {" "}*
                                                </span>

                                            </Form.Label>


                                            <Form.Control
                                                type="text"
                                                name="phone"
                                                value={
                                                    formData.phone
                                                }
                                                onChange={(e) =>
                                                    handleNumberChange(
                                                        e,
                                                        10
                                                    )
                                                }
                                                maxLength={10}
                                                placeholder="Enter 10 digit mobile number"
                                                required
                                            />

                                        </Form.Group>

                                    </Col>


                                    {/* Email */}

                                    <Col md={4}>

                                        <Form.Group>

                                            <Form.Label>

                                                Email

                                                <span className="text-danger">
                                                    {" "}*
                                                </span>

                                            </Form.Label>


                                            <Form.Control
                                                type="email"
                                                name="email"
                                                value={
                                                    formData.email
                                                }
                                                onChange={
                                                    handleChange
                                                }
                                                placeholder="Enter email address"
                                                required
                                            />

                                        </Form.Group>

                                    </Col>


                                    {/* Password */}

                                    <Col md={4}>

                                        <Form.Group>

                                            <Form.Label>

                                                Password

                                                <span className="text-danger">
                                                    {" "}*
                                                </span>

                                            </Form.Label>


                                            <Form.Control
                                                type="password"
                                                name="password"
                                                value={
                                                    formData.password
                                                }
                                                onChange={
                                                    handleChange
                                                }
                                                placeholder="Create password"
                                                required
                                            />

                                        </Form.Group>

                                    </Col>

                                </Row>


                                {/* ================================= */}
                                {/* EMPLOYMENT DETAILS */}
                                {/* ================================= */}

                                {/* <h5 className="mb-3 mt-4">
                                    Employment Details
                                </h5> */}


                                <Row className="mb-3">


                                    {/* Joining Date */}

                                    <Col md={4}>

                                        <Form.Group>

                                            <Form.Label>

                                                Joining Date

                                                <span className="text-danger">
                                                    {" "}*
                                                </span>

                                            </Form.Label>


                                            <Form.Control
                                                type="date"
                                                name="joiningDate"
                                                value={
                                                    formData.joiningDate
                                                }
                                                onChange={
                                                    handleChange
                                                }
                                                required
                                            />

                                        </Form.Group>

                                    </Col>


                                    {/* Role */}

                                    <Col md={4}>

                                        <Form.Group>

                                            <Form.Label>

                                                Role

                                                <span className="text-danger">
                                                    {" "}*
                                                </span>

                                            </Form.Label>


                                            <Form.Select
                                                name="role"
                                                value={
                                                    formData.role
                                                }
                                                onChange={
                                                    handleChange
                                                }
                                                required
                                            >

                                                <option value="">
                                                    Select Role
                                                </option>


                                                {
                                                    userRoles.map(
                                                        (item, index) => (

                                                            <option
                                                                key={
                                                                    index
                                                                }
                                                                value={
                                                                    item.id
                                                                }
                                                            >

                                                                {
                                                                    item.name
                                                                }

                                                            </option>

                                                        )
                                                    )
                                                }

                                            </Form.Select>

                                        </Form.Group>

                                    </Col>


                                    {/* Aadhaar */}

                                    <Col md={4}>

                                        <Form.Group>

                                            <Form.Label>

                                                Aadhaar Card Number

                                                <span className="text-danger">
                                                    {" "}*
                                                </span>

                                            </Form.Label>


                                            <Form.Control
                                                type="text"
                                                name="aadhaarCardNumber"
                                                value={
                                                    formData.aadhaarCardNumber
                                                }
                                                onChange={(e) =>
                                                    handleNumberChange(
                                                        e,
                                                        12
                                                    )
                                                }
                                                maxLength={12}
                                                placeholder="Enter 12 digit Aadhaar number"
                                                required
                                            />

                                        </Form.Group>

                                    </Col>

                                </Row>


                                {/* ================================= */}
                                {/* RETIREMENT DATE */}
                                {/* ================================= */}

                                <Row className="mb-3" style={{ display: "none" }}>

                                    <Col md={4}>

                                        <Form.Group>

                                            <Form.Label>
                                                Retirement Date
                                            </Form.Label>


                                            <Form.Control
                                                type="date"
                                                name="retirementDate"
                                                value={
                                                    formData.retirementDate
                                                }
                                                disabled
                                            />


                                            <Form.Text
                                                className="text-muted"
                                            >
                                                Automatically calculated
                                                based on Date of Birth.
                                            </Form.Text>

                                        </Form.Group>

                                    </Col>

                                </Row>


                                {/* ================================= */}
                                {/* SUBMIT */}
                                {/* ================================= */}

                                <div className="text-center mt-4">

                                    {/* <Button
                                        variant="primary"
                                        type="submit"
                                        disabled={loading}
                                    >

                                        {
                                            loading
                                                ? "Registering..."
                                                : "Register"
                                        }

                                    </Button> */}
                                    <Button variant="primary" type="submit" disabled={loading}>
                                        {loading ? (
                                            <>
                                                <span
                                                    className="spinner-border spinner-border-sm me-2"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>
                                                Registering...
                                            </>
                                        ) : (
                                            "Register"
                                        )}
                                    </Button>

                                </div>

                            </Form>

                        </Card.Body>

                    </Card>

                </Col>

            </Row>
            {/* Bootstrap Modal */}
            {showModal && (
                <div
                    className="modal fade show"
                    style={{ display: "block" }}
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="successModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="successModalLabel">
                                    Registration Successful
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={handleCloseModal}
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p dangerouslySetInnerHTML={{ __html: greetingMessage }} />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={handleCloseModal}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar
                newestOnTop
                closeOnClick
                rtl
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ width: "35%" }}
            />
        </>
    );
};

export default NewUserRegistration;